import { Block, Button, checkMark, Image, palette, spacing, Typography } from "@stepapp/ui";
import { useRouter } from "expo-router";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withSpring,
} from "react-native-reanimated";
import { footerStyle } from "../../../../src/styles/themes";

const ReviewSentScreen = () => {
  const { t } = useTranslation();
  const { replace } = useRouter();

  const checkmarkScale = useSharedValue(0);

  const navigateToCalendar = useCallback(() => {
    replace("/calendar");
  }, [replace]);

  checkmarkScale.value = withDelay(
    200,
    withSpring(1, {
      damping: 10,
      stiffness: 150,
      mass: 1,
    }),
  );

  const checkmarkAnimatedStyle = useAnimatedStyle(() => {
    return {
      transform: [{ scale: checkmarkScale.value }],
    };
  });

  return (
    <Block style={styles.container}>
      <Block>
        <Animated.View style={[styles.checkMarkContainer, checkmarkAnimatedStyle]}>
          <Image
            height={spacing.unit * 10}
            source={checkMark}
            width={spacing.unit * 10}
            // @ts-expect-error
            style={styles.checkMarkImage}
          />
        </Animated.View>

        <Typography center variant="navLink">
          {t("screens.serviceAcceptedOverlay.thankYou")}
        </Typography>
        <Typography center variant="paragraph" style={styles.text}>
          {t("screens.serviceAcceptedOverlay.reviewSubmitted")}
        </Typography>
      </Block>

      <Block style={[footerStyle, styles.footer]}>
        <Button label={t("common.close")} onPress={navigateToCalendar} type="primary" />
      </Block>
    </Block>
  );
};

export default ReviewSentScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  checkMarkContainer: {
    alignItems: "center",
    justifyContent: "center",
    marginBottom: spacing.unit * 8,
    marginTop: spacing.unit * 10,
    backgroundColor: `${palette.primary.accent}10`,
    borderRadius: 100,
    width: 100,
    height: 100,
    margin: "auto",
  },
  text: {
    marginTop: spacing.unit * 2,
    paddingHorizontal: spacing.unit,
  },
  checkMarkImage: {
    tintColor: palette.primary.accent,
  },
  footer: {
    borderTopWidth: 0,
  },
});
